import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Header from "./screens/component/Header";
import Footer from "./screens/component/Footer";
import Dashboard from './screens/Dashboard';
import Country from './screens/country/Country';
import Login from './screens/Login';
import Registration from './screens/Registration';
import CountryProducts from './screens/country/CountryProducts';
import CountryEvents from './screens/country/CountryEvents';
import CountryDocuments from './screens/country/CountryDocuments';
import CountryCenters from './screens/country/CountryCenters';
import CountryUsers from './screens/country/CountryUsers';
import AboutUs from './screens/AboutUs';
import SearchResult from './screens/SearchResult';
import AboutIndia from './screens/AboutIndia';
import AyushGlobal from './screens/AyushGlobal';
import OpportunitiesForStudents from './screens/OpportunitiesForStudents';
import WebsitePolicies from './screens/WebsitePolicies';
import TermsCondition from './screens/TermsConditions';
import HelpFeedback from './screens/HelpFeedback';
import AyushChairs from './screens/AyushChairs';
import GlobalCollab from './screens/GlobalCollab';
import StatusInIndia from './screens/StatusInIndia';
import ProductCertificatesApproval from './screens/my-account/ProductCertificatesApproval';
import ResetPassword from "./screens/common/ResetPassword.js";
import ForgotPwd from "./screens/ForgotPwd";
import ForgotPwd2 from "./screens/ForgotPwd2";
import ForgotPwd3 from "./screens/ForgotPwd3";
//common modules
import AddEditProduct from "./screens/common/products/AddEditProduct";
import ProductDetails from "./screens/common/products/ProductDetails";
import EventDetails from "./screens/common/events/EventDetails";
import AddEditEvent from "./screens/common/events/AddEditEvent";
import AddDocuments from "./screens/common/documents/AddDocuments";
import AddScheme from "./screens/common/schemes/AddScheme";
//superadmin
import ViewAllEvents from "./screens/my-account/superadmin/events/ViewAllEvents";
import ViewProducts from "./screens/my-account/superadmin/products/ViewProducts";
import SuperadminDashboard from "./screens/my-account/superadmin/SuperadminDashboard";
import ViewCountries from "./screens/my-account/superadmin/country/ViewCountries";
import CountriesDetails from "./screens/my-account/superadmin/country/CountriesDetails";
import AddEditCountry from "./screens/my-account/superadmin/country/AddEditCountry";
import PortalStatistics from "./screens/my-account/superadmin/statistics/PortalStatistics";
import AllUsers from "./screens/my-account/superadmin/users/AllUsers";
import CreateUser from "./screens/my-account/superadmin/users/AssociationPractitioner/CreateUser.js";
import AllDocuments from "./screens/my-account/superadmin/documents/AllDocuments";
import AllSchemes from "./screens/my-account/superadmin/schemes/AllSchemes";
//practitioner
import MyCenters from "./screens/my-account/Practitioner/MyCenters";
import PractitionerDashboard from "./screens/my-account/Practitioner/PractitionerDashboard";
import PractitionersProducts from "./screens/my-account/Practitioner/practitioner/PractitionersProducts";
import MyEvents from "./screens/my-account/Practitioner/events/MyEvents";
import EditPractitionerDetails from "./screens/my-account/Practitioner/practitioner/EditPractitionerDetails";
import ViewPractitionerProducts from "./screens/my-account/Practitioner/products/ViewProducts";
//mission
import MissionAnnouncements from "./screens/my-account/mission/Announcement/MissionAnnouncements";
import MissionDashboard from "./screens/my-account/mission/MissionDashboard";
import ViewAnnouncements from "./screens/my-account/mission/Announcement/ViewAnnouncements";
import AddAnnouncements from "./screens/my-account/mission/Announcement/AddAnnouncements";
import MissionEvents from "./screens/my-account/mission/Events/MissionEvents";
// import ApproveEvents from "./screens/my-account/mission/Events/ApproveEvents";
import PractitionersList from "./screens/my-account/mission/Practitioner/PractitionersList";
// import AddMyPractitionerData from './screens/my-account/mission/Practitioner/AddMyPractitionerData';
import MissionAllProducts from "./screens/my-account/mission/Products/MissionAllProducts";
import PractitionersProductsList from "./screens/my-account/mission/Practitioner/PractitionersProductsList";
import MissionDocuments from "./screens/my-account/mission/Documents/AllDocuments";
import MissionAllSchemes from "./screens/my-account/mission/Schemes/MissionAllSchemes";
//
import { connect } from "react-redux";
import PrivateRoute from "./PrivateRoute";
import * as translationAction from "./actions/translation";
import { translation } from "./lib/utils";
import { GlobalLoading } from "react-global-loading";

class App extends Component {
  render() {
    const { userData } = this.props;
    return (
      <>
        <GlobalLoading />
        <Header />
        <Switch>
          <Route path="/" component={Dashboard} exact />
          <Route path="/country/:country/:id" component={Country} />
          <Route path="/login" component={Login} />
          <Route path="/registration" component={Registration} exact />
          <Route path="/forgot-password" component={ForgotPwd} exact />
          <Route path="/forgot-password-step2" component={ForgotPwd2} exact />
          <Route
            path="/country-products/:id/:catId"
            component={CountryProducts}
            exact
          />
          <Route
            path="/country-events/:id/:catId"
            component={CountryEvents}
            exact
          /><Route
            path="/search-result/:query"
            component={SearchResult}
            exact
          />
          <Route
            path="/country-documents/:id/:catId"
            component={CountryDocuments}
            exact
          />
          <Route
            path="/country-centers/:id/:catId"
            component={CountryCenters}
            exact
          />
          <Route
            path="/country-users/:id/:catId"
            component={CountryUsers}
            exact
          />
          <Route path="/about-us" component={AboutUs} exact />
          <Route path="/about-india" component={AboutIndia} exact />
          <Route path="/ayush-global" component={AyushGlobal} exact />
          <Route path="/country-product-details" component={ProductDetails} />
          <Route path="/country-event-details" component={EventDetails} />
          <Route
            path="/opportunity-for-students"
            component={OpportunitiesForStudents}
          />
          <Route path="/term-condition" component={TermsCondition} />
          <Route path="/help-feedback" component={HelpFeedback} />
          <Route path="/website-policy" component={WebsitePolicies} />
          <Route path="/ayush-chairs" component={AyushChairs} />
          <Route path="/global-collab" component={GlobalCollab} />
          <Route path="/status-in-india" component={StatusInIndia} />
          <Route
            component={() => (
              <>
                <PrivateRoute
                  isAuthenticated={userData}
                  path={[
                    "/create-event",
                    "/edit-event",
                    "/add-practitioner-events",
                    "/edit-practitioner-events",
                    "/mission/create-event",
                  ]}
                  component={AddEditEvent}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path={[
                    "/add-product",
                    "/edit-product",
                    "/add-practitioner-products",
                    "/edit-practitioner-products",
                    "/add-mission-products",
                    "/edit-mission-products"
                  ]}
                  component={AddEditProduct}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path={[
                    "/mission-products-detail",
                    "/product-practitioner-details",
                  ]}
                  component={ProductDetails}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path={[
                    "/event-practitioner-details",
                    "/mission-event-detail",
                  ]}
                  component={EventDetails}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/add-mission-documents"
                  component={AddDocuments}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/mission/add-scheme"
                  component={AddScheme}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/my-events"
                  component={MyEvents}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/mission-events"
                  component={MissionEvents}
                />
                {/* <PrivateRoute
                  isAuthenticated={userData}
                  path="/approve-events"
                  component={ApproveEvents}
                /> */}
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/my-centers"
                  component={MyCenters}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/mission-dashboard"
                  component={MissionDashboard}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/product-certificates-approval"
                  component={ProductCertificatesApproval}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/mission-announcements"
                  component={MissionAnnouncements}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/view-announcements"
                  component={ViewAnnouncements}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/create-announcements"
                  component={AddAnnouncements}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/view-practitioner-events"
                  component={MyEvents}
                />

                {/* <PrivateRoute isAuthenticated={userData} path={['/edit-practice-data', '/view-practice-data']} component={EditPractitionerDetails} /> */}
                {/* <PrivateRoute isAuthenticated={userData} path='/view-practice-data' component={EditPractitionerDetails} /> */}

                <PrivateRoute
                  isAuthenticated={userData}
                  path="/practitioner-dashboard"
                  component={PractitionerDashboard}
                />

                <PrivateRoute
                  isAuthenticated={userData}
                  path="/practitioners-products"
                  component={PractitionersProducts}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/view-practitioner-products"
                  component={ViewPractitionerProducts}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/practitioners-list"
                  component={PractitionersList}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/mission-all-products"
                  component={MissionAllProducts}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/practitioners-products-list/:id"
                  component={PractitionersProductsList}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/mission-documents"
                  component={MissionDocuments}
                /><PrivateRoute
                  isAuthenticated={userData}
                  path="/reset-password"
                  component={ResetPassword}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/add-schemes"
                  component={AddScheme}
                />
                <PrivateRoute
                  isAuthenticated={userData}
                  path="/mission-all-schemes"
                  component={MissionAllSchemes}
                />

                <SuperadminDashboard>
                  <Route
                    component={() => (
                      <>
                        <PrivateRoute
                          isAuthenticated={userData}
                          path="/super/portal-statistics"
                          component={PortalStatistics}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path={[
                            "/view-practice-data",
                            "/add-my-practitioner-data",
                          ]}
                          component={CreateUser}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path="/super/forgot-password-step3"
                          component={ForgotPwd3}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path="/super/view-country"
                          component={ViewCountries}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path="/super/countries-details"
                          component={CountriesDetails}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path={["/super/add-country", "/super/edit-country"]}
                          component={AddEditCountry}
                        />
                        {/* product */}
                        <PrivateRoute
                          isAuthenticated={userData}
                          path="/super/view-products"
                          component={ViewProducts}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path={["/super/create-event", "/super/update-event"]}
                          component={AddEditEvent}
                        />
                        {/* <PrivateRoute isAuthenticated={userData} path={['/add-my-practitioner-data']} component={CreateUser} /> */}
                        <PrivateRoute
                          isAuthenticated={userData}
                          path={["/super/update-product", "/super/add-product"]}
                          component={AddEditProduct}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path={[
                            "/super/products-detail",
                            "/super/update-product-status",
                            "/mission-products-detail",
                            "/product-practitioner-details",
                          ]}
                          component={ProductDetails}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path={["/super/event-details"]}
                          component={EventDetails}
                        />

                        {/* event */}
                        <PrivateRoute
                          isAuthenticated={userData}
                          path="/super/view-all-events"
                          component={ViewAllEvents}
                        />
                        {/* user */}

                        <PrivateRoute
                          isAuthenticated={userData}
                          path="/super/all-users"
                          component={AllUsers}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path="/super/all-documents"
                          component={AllDocuments}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path="/super/add-documents"
                          component={AddDocuments}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path="/super/all-schemes"
                          component={AllSchemes}
                        />
                        <PrivateRoute
                          isAuthenticated={userData}
                          path="/super/add-scheme"
                          component={AddScheme}
                        />
                      </>
                    )}
                  />
                </SuperadminDashboard>
              </>
            )}
          />
        </Switch>
        <Footer />
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    userData: state.userData,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    addToTranslation: translation
      ? translation =>
        dispatch(translationAction?.addToTranslation(translation))
      : "",
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
